import React from 'react'
import { SEARCH_FIELD_PROPS } from '../../../../../../../shared/component/search-field-props'

export const SelectListFilter = ({ value, onChange }) => {
  const handleChange = e => onChange && onChange(e.target.value.toLowerCase())
  return <input {...SEARCH_FIELD_PROPS} name="list-filter" aria-label="search" className="form-control" value={value} placeholder="search" onChange={handleChange} />
}
